import { css, cx } from '@eti/styles';
import { breakpoints, Card, Inline, Stack, vars } from '@etg/wings';
import { BrandLogo } from '@eti/components';
import { useSiteContext } from '@eti/providers';
import {
  getLogoHeightDesktop,
  getLogoWidthDesktop,
} from '../../../../../../main/components/SiteLogo';
import { useGFSBackgroundImage } from '../../../../../../utils/backgroundImage';
import GFSBannerUSP from './GFSBannerUSP';

const brandLogoStyles = (brand: string, siteName: string) => css`
  @media (min-width: ${breakpoints._768}) {
    height: ${getLogoHeightDesktop(brand, siteName)};
    margin: 0 auto;
    max-width: ${getLogoWidthDesktop(brand)};
    transform: scale(0.8);
  }
`;

const inlineStyles = css`
  border-bottom-right-radius: ${vars.card.borderRadius};
  border-top-right-radius: ${vars.card.borderRadius};
  height: 100%;
  min-height: 290px;
`;

const cardStyles = css`
  max-width: 311px;
  opacity: 0.8;
  padding: 20px;
`;

const GFSBanner = () => {
  const { cssClass } = useGFSBackgroundImage();
  const { brand, siteName } = useSiteContext();

  return (
    <Inline
      align="center"
      alignY="center"
      className={cx(inlineStyles, cssClass)}
      data-testid="gfs-banner"
    >
      <Card className={cardStyles}>
        <Stack>
          <BrandLogo
            brand={brand.code}
            className={brandLogoStyles(brand.code, siteName)}
            data-testid="gfs-banner-logo"
            shouldUseContrast
            siteName={siteName}
          />
          <GFSBannerUSP />
        </Stack>
      </Card>
    </Inline>
  );
};

export default GFSBanner;
